// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1cPOD","fileBtn":"File_fileBtn__1e0fI","closeBtn":"File_closeBtn__2b6bt","fileSelected":"File_fileSelected__iZWqM","disabled":"File_disabled__2nf0z"};